import { MARKETPLACE_AI_COURSES_SEARCH_URL } from '@/config/weblinks'
import { SidebarLayout } from '@/shared/components/SidebarLayout'
import { useFeatureFlags } from '@/shared/hooks/useFeatureFlags'
import NotFound from '@/static-pages/NotFound'
import { useEffect } from 'react'
import { LearningRecommendationsList } from '../components/LearningRecommendationsList'
import { LearningRecommendationsPageHeader } from '../components/LearningRecommendationsPageHeader'
import { useLearningRecommendationsDataFetching } from '../hooks/useLearningRecommendationsDataFetching'

export function LearningRecommendationsPage() {
  const [isRecommendationsPageEnabled] = useFeatureFlags([
    'learningRecommendationsPage',
  ])

  const {
    lastRecommendation,
    listState,
    generateRecommendationsAndStartPolling,
  } = useLearningRecommendationsDataFetching({
    enabled: isRecommendationsPageEnabled,
  })

  useEffect(() => {
    document.title = 'Learning Recommendations | Mydra'
  }, [])

  if (!isRecommendationsPageEnabled) {
    return <NotFound />
  }

  return (
    <SidebarLayout>
      <div className="flex h-full flex-col gap-4 px-3 py-12 md:gap-6 md:px-5 md:py-6">
        <LearningRecommendationsPageHeader />
        <LearningRecommendationsList
          state={listState}
          title="Based on your level and role, updated as your skills evolve."
          ctaButton={{
            href: MARKETPLACE_AI_COURSES_SEARCH_URL,
            label: 'Explore all courses',
          }}
          items={lastRecommendation?.items}
          accentColors={['#F0926C', '#FCF2AD', '#CFB9FE']}
          maxItems={10}
          onRetry={generateRecommendationsAndStartPolling}
          className="flex-1"
        />
      </div>
    </SidebarLayout>
  )
}
